import { useAuth0 } from "@auth0/auth0-react";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";

export default function AuthenticationButton() {
  const { isAuthenticated, user } = useAuth0();

  if (isAuthenticated) {
    const { name, picture, givenName } = user;
    return (
      <div className="flex flex-row items-center font-medium gap-3">
        <div>
          <img src={picture} alt={givenName} className="rounded-lg w-12" />
        </div>
        <div>{name}</div>
        <div>
          <LogoutButton />
        </div>
      </div>
    );
  }

  return <LoginButton />;
}
